import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import arrLeft from '../../../assets/img/arrow-gallery-left.png';
import arrRight from '../../../assets/img/arrow-gallery-right.png';
import icoClose from '../../../assets/img/ico-close.png';
import icoFacebook from '../../../assets/img/ico-share-facebook.png';
import icoTwitter from '../../../assets/img/ico-share-twitter.png';
import icoEmail from '../../../assets/img/ico-share-email.png';
import { MONTHS, ROUTING } from '../../../constants';
import * as utils from '../../../utils';
import * as api from '../../../api';
import './EntryDetail.css';
import { daySelectSwitch } from '../../../redux/actions';
import { PATH } from '../../../constants';

// todo - 'close-bg' is not ideal, for final version
// todo - ...find a solution to active close even during scroll
// todo - add slideshow browse - with some bullet points
// todo - set final airtime values - after redux implementation
// todo - gallery navigation is just raw for now
// todo - polish "stranka poradu" link implementation

class EntryDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: true,
      error: false,
      activeFrame: 0, // for gallery
      imageDetail: '', // to show image detail overlay
      entryData: {}
    };
  }

  // -------------------------------------------------------
  // Component
  // -------------------------------------------------------

  componentWillMount() {
    this.setState({
      fetching: true,
      error: false,
      activeFrame: 0,
      imageDetail: '',
      entryData: {}
    });
  }

  componentDidMount() {
    // try hide date select
    this.props.daySelectSwitch(false);
    // set data
    api
      .fetchEntry(
        this.props.match.params.entryId,
        this.props.match.params.timeId
      )
      .then(data => {
        this.setState({
          fetching: false,
          entryData: data
        });
      })
      .catch(() => {
        this.setState({
          fetching: false,
          error: true
        });
      });
  }

  // -------------------------------------------------------
  // TODO
  // -------------------------------------------------------

  // todo - rename
  getNextFrame(updateValue) {
    let newFrame = this.state.activeFrame + updateValue;
    if (newFrame < 0) {
      newFrame = this.state.entryData.galleryLength - 1;
    } else if (newFrame >= this.state.entryData.galleryLength) {
      newFrame = 0;
    }
    this.setState({
      activeFrame: newFrame
    });
  }

  getImagePath(imageId) {
    return this.state.entryData.gallery[
      this.state.entryData.galleryOrder[imageId]
    ];
  }

  getImageContent(imageId) {
    const imgData = this.getImagePath(imageId);
    return (
      <button
        className="image-wrap"
        onClick={() => this.showImageDetail(imgData.img)}
      >
        <div className="image-helper" />
        <img
          className="image"
          src={`https://storage.googleapis.com/stoleti-img/${imgData.img}.jpg`}
          alt={this.state.entryData.title}
        />
        {imgData.label.length > 0 && (
          <div className="imgLabel">{imgData.label}</div>
        )}
      </button>
    );
  }

  getActualContent() {
    if (this.state.entryData.isVideo) {
      if (this.state.activeFrame === 0) {
        const videoUrl = this.state.entryData.programme.idec
          .replace(/ /g, '')
          .replace(/\//g, '');
        return (
          <iframe
            title="Video"
            src={`${PATH.FRAME}/?hash=${api.getHash()}&IDEC=${videoUrl}&origin=noads`}
            allowFullScreen
          />
        );
      }
      return this.getImageContent(this.state.activeFrame - 1);
    }
    return this.getImageContent(this.state.activeFrame);
  }

  // -------------------------------------------------------
  // Sharing
  // -------------------------------------------------------

  getShareUrl() {
    return `http://www.ceskatelevize.cz/specialy/totostoleti/program-68#/detail/${
      this.props.match.params.entryId
    }/${this.props.match.params.timeId}`;
  }

  shareFacebook() {
    // todo - quick temp
    const FB = window.FB;
    FB.ui(
      {
        method: 'share_open_graph',
        action_type: 'og.shares',
        action_properties: JSON.stringify({
          object: {
            'og:url': this.getShareUrl(),
            'og:title': this.state.entryData.title,
            'og:description':
              'Unikátní projekt České televize: TV program z roku 1968',
            'og:image:url': this.state.entryData.isVideo
              ? this.state.entryData.programme.data.programme.imageURL
              : `https://storage.googleapis.com/stoleti-img/${
                  this.getImagePath(0).img
                }.jpg`
          }
        })
      },
      () => {}
    );
    utils.statsEvent('share', 'fb');
  }

  shareTwitter() {
    window.open(
      `//twitter.com/share?url=${this.getShareUrl().replace(
        '#',
        '%23'
      )}&amp;text=${this.state.entryData.title}&amp;hashtags=totostoleti`,
      'Twitter',
      'height=285,width=550'
    );
    utils.statsEvent('share', 'twitter');
  }

  shareEmail() {
    window.location.href = `mailto:@?subject=Program 68&body=${
      this.state.entryData.title
    } ${this.getShareUrl()}`;
    utils.statsEvent('share', 'email');
  }

  // -------------------------------------------------------
  // Image detail
  // -------------------------------------------------------

  showImageDetail(img) {
    this.setState({
      imageDetail: `https://storage.googleapis.com/stoleti-img/${img}-full.jpg`
    });
  }

  getImageDetail() {
    return (
      <button
        className="image-detail"
        onClick={() => {
          this.setState({ imageDetail: '' });
        }}
      >
        <img
          className="img-content"
          src={this.state.imageDetail}
          alt="Detail"
        />
        <img className="img-close" src={icoClose} alt="Zavřít" />
      </button>
    );
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    // todo - temp raw solution
    const loaded = !this.state.fetching && !this.state.error;
    const imageDetail = this.state.imageDetail.length > 0;

    const { timeData } = this.state.entryData;

    return (
      <div id="entry-detail">
        <div className="bg" />
        <div className={`content-wrap ${imageDetail ? 'mode-detail' : ''}`}>
          <Link className="close-bg" to={ROUTING.HOME} />
          <div className="content">
            <div className="head">
              <div className="top">
                {loaded && (
                  <div className="airtime">
                    {`${timeData.dayName} ${timeData.idDay + 1}. ${
                      MONTHS[timeData.idMonth]
                    } ${timeData.idYear}`}{' '}
                    <span className="time">{timeData.time}</span>
                  </div>
                )}
                <Link className="btn-back" to={ROUTING.HOME}>
                  <img src={icoClose} alt="Zavřít" />
                </Link>
              </div>
              {loaded && (
                <div className="title">{this.state.entryData.title}</div>
              )}
              {this.state.error && (
                <div className="error">
                  Litujeme, zvolený pořad není dostupný.
                </div>
              )}
            </div>
            {loaded && (
              <div className="data-wrap">{this.getActualContent()}</div>
            )}
            {loaded &&
              this.state.entryData.galleryLength > 1 && (
                <div className="gallery-nav">
                  <button
                    className="btn-gallery-nav left"
                    onClick={() => this.getNextFrame(-1)}
                  >
                    <img src={arrLeft} alt="Předchozí" />
                  </button>
                  <div className="gallery-nav-num">
                    {this.state.activeFrame + 1}/{
                      this.state.entryData.galleryLength
                    }
                  </div>
                  <button
                    className="btn-gallery-nav right"
                    onClick={() => this.getNextFrame(1)}
                  >
                    <img src={arrRight} alt="Další" />
                  </button>
                </div>
              )}
            {loaded && (
              <div className="info">
                {this.state.entryData.descLong &&
                  this.state.entryData.descLong !== '' && (
                    <div className="descLong">
                      {this.state.entryData.descLong}
                    </div>
                  )}
                {this.state.entryData.note !== '' && (
                  <div className="note">{this.state.entryData.note}</div>
                )}
                {this.state.entryData.isVideo &&
                  this.state.entryData.programme.data.programme.webURL && (
                    <a
                      className="show-link"
                      href={this.state.entryData.programme.data.programme.webURL.replace(
                        'ivysilani',
                        'porady'
                      )}
                      target="_blank"
                    >
                      Stránka pořadu
                    </a>
                  )}
                <div className="sharing">
                  <div className="wrap">
                    <button
                      className="share-0"
                      onClick={() => this.shareFacebook()}
                    >
                      <img src={icoFacebook} alt="Facebook" />
                    </button>
                    <button
                      className="share-1"
                      onClick={() => this.shareTwitter()}
                    >
                      <img src={icoTwitter} alt="Twitter" />
                    </button>
                    <button
                      className="share-2"
                      onClick={() => this.shareEmail()}
                    >
                      <img src={icoEmail} alt="Email" />
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {imageDetail && this.getImageDetail()}
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  daySelectSwitch: show => dispatch(daySelectSwitch(show))
});

export default connect(mapStateToProps, mapDispatchToProps)(EntryDetail);



// WEBPACK FOOTER //
// ./src/components/App/EntryDetail/EntryDetail.js